import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import type {QueryPersister} from '@github-ui/react-query'

/**
 * Shorthand for creating a query config that fetches from a pull request's `page_data` endpoint.
 * Builds the pathname as `/:owner/:repo/pull/:pr_number/page_data/:name`.
 *
 * By default the response is fetched with `queryFnFetch`. Pass `options.queryFn`
 * to supply a custom fetcher — e.g. one that decodes a Protobuf response and/or
 * normalizes a legacy payload to the canonical shape. The custom `queryFn` is
 * responsible for any schema validation/decoding it needs.
 */
export function pageDataQuery<Res, Name extends string>(
  name: Name,
  enabled: boolean | (() => boolean) = true,
  options?: {
    persister?: QueryPersister
    queryFn?: (queryKey: Parameters<typeof queryFnFetch>[0]) => Promise<Res>
  },
) {
  return {
    queryName: name,
    queryDeps: ({params}: {params: {owner: string; repo: string; pr_number: string}}) => ({
      pathname: `/${params.owner}/${params.repo}/pull/${params.pr_number}/page_data/${name}`,
    }),
    queryFn: options?.queryFn ?? (async (queryKey: Parameters<typeof queryFnFetch>[0]) => queryFnFetch<Res>(queryKey)),
    enabled,
    ...(options?.persister ? {persister: options.persister} : {}),
  }
}
